import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import PageAtmosphere from './PageAtmosphere';
import './Marketing.css';

export default function PricingPage() {
  return (
    <div className="marketing-page marketing-page--atmosphere">
      <Seo
        title="Pricing — 3AM AI Life Journal"
        description="Simple pricing for Life Journal by 3AM AI. Start free, or go Pro for unlimited AI coaching, deeper insights, and full goal tracking."
        path="/pricing"
      />
      <PageAtmosphere />
      <SiteNav />
      <main>
        <header className="page-hero">
          <div className="page-hero__inner m-animate-in">
            <h1>Simple pricing</h1>
            <p>Start free. Upgrade when you want the full coach and deeper insight.</p>
          </div>
        </header>

        <div className="pricing-grid">
          <article className="price-card m-animate-in">
            <h2 className="price-card__name">Free</h2>
            <p className="price-card__desc">Everything you need to begin journaling with clarity.</p>
            <p className="price-card__price">
              $0 <span>/ month</span>
            </p>
            <p className="price-card__period">Forever free</p>
            <ul>
              <li>Private life journal</li>
              <li>Mood tracking</li>
              <li>Goal basics</li>
              <li>Limited AI coach messages</li>
            </ul>
            <Link to="/signup" className="m-btn m-btn--ghost">
              Start free
            </Link>
          </article>

          <article className="price-card price-card--featured m-animate-in m-animate-in--delay-1">
            <h2 className="price-card__name">Pro</h2>
            <p className="price-card__desc">For people who want depth, continuity, and full momentum.</p>
            <p className="price-card__price">
              $12 <span>/ month</span>
            </p>
            <p className="price-card__period">Or $99 / year (save ~30%)</p>
            <ul>
              <li>Everything in Free</li>
              <li>Unlimited AI coach</li>
              <li>Full goal tracking &amp; reviews</li>
              <li>Deeper mood &amp; pattern insights</li>
              <li>Priority access to new features</li>
            </ul>
            <Link to="/signup" className="m-btn m-btn--primary">
              Go Pro
            </Link>
          </article>
        </div>

        <p className="pricing-note">
          Cancel anytime. No lock-in. Billing for Pro is coming soon — early users can start free today.
        </p>

        <section className="cta-band" aria-labelledby="pricing-cta">
          <h2 id="pricing-cta">Not sure yet?</h2>
          <p>See how journal → mood → goals → AI coach fits together — then start free.</p>
          <div className="m-btn-row">
            <Link to="/product#journey" className="m-btn m-btn--ghost">
              How it works
            </Link>
            <Link to="/signup" className="m-btn m-btn--primary">
              Create your account
            </Link>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
